import axios from 'axios';
import root from 'window-or-global';
import Url from '../constants/Url';
import SubscriptionActions from '../actions/SubscriptionActions';

/**
 * SubscriptionSource
 *
 * Ajax calls for user subscription
 *
 * For more information on source usage:
 * http://alt.js.org/docs/async/
 *
 */

const xhr = {
    getHeader: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-EPIC-RETURN-JSON-IF-NO-AUTH': true
    },
    postHeader: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

const SubscriptionSource = {
    subscribeEmail: {
        remote(state) {
            return axios.post(`${Url().SUBSCRIBE.ADD}`, {
                headers: xhr.getHeader
            });
        },
        success: SubscriptionActions.subscribeEmailSuccess,
        error: SubscriptionActions.subscribeEmailFailure,
        shouldFetch() {
            return !root.__server_side_render;
        }
    }
};

export default SubscriptionSource;
